var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBulkMessge({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1334 10V3.6C14.1334 2.71634 13.417 2 12.5334 2H2.93337C2.04972 2 1.33337 2.71634 1.33337 3.6V10C1.33337 10.8837 2.04972 11.6 2.93337 11.6H5.33337L7.73337 14L10.1334 11.6H12.5334C13.417 11.6 14.1334 10.8837 14.1334 10ZM3.73337 5.2C3.73337 4.75817 4.09155 4.4 4.53337 4.4H10.9334C11.3752 4.4 11.7334 4.75817 11.7334 5.2C11.7334 5.64183 11.3752 6 10.9334 6H4.53337C4.09155 6 3.73337 5.64183 3.73337 5.2ZM4.53337 7.6C4.09155 7.6 3.73337 7.95817 3.73337 8.4C3.73337 8.84183 4.09155 9.2 4.53337 9.2H6.93337C7.3752 9.2 7.73337 8.84183 7.73337 8.4C7.73337 7.95817 7.3752 7.6 6.93337 7.6H4.53337Z",
    fill: "#23242A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulkMessge);
export default __webpack_public_path__ + "static/media/bulk-messge.d7c525ae851988f5187e4ff2a9271922.svg";
export { ForwardRef as ReactComponent };